import { LoadablePaint } from '@confluence/loadable';

export const ShareableLinksMainLayout = LoadablePaint({
	_reactTreeRootForServerPlaceholderId: true,
	name: 'ShareableLinksMainLayout',
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareableLinksMainLayout" */ '../src/shareable-links/ShareableLinksMainLayout.tsx'
			)
		).ShareableLinksMainLayout,
});
